import { render, staticRenderFns } from "./insPaymentPosting.vue?vue&type=template&id=85adab12&"
import script from "./insPaymentPosting.vue?vue&type=script&lang=js&"
export * from "./insPaymentPosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports